// /opt/isp_erp/frontend/src/utils/contextoBodega.js
import axios from "../api/axios";

let cache = { token: null, promesa: null };

/** Contexto del usuario en las sucursales de bodega ({ central, admin, sucursal_id, ... }); null si no se pudo saber.
 *  Se consulta una vez por sesión. central === false significa que es encargado de una sucursal. */
export const cargarContextoBodega = () => {
  const token = sessionStorage.getItem("token");
  if (!token) return Promise.resolve(null);
  if (cache.token !== token || !cache.promesa) {
    const promesa = axios.get("/warehouse/sucursales/contexto")
      .then((r) => r.data)
      .catch(() => {
        if (cache.promesa === promesa) cache = { token: null, promesa: null };
        return null;
      });
    cache = { token, promesa };
  }
  return cache.promesa;
};
